export default (time) => time
  .substring(0, 5)
  .replace(/[^\d]/g, '')
  .replace(/^(\d{2})/, '$1:')
  .replace(/^(\d{2}):(\d{2})/, '$1:$2');
